// Used by components that wrap third-party/shared widgets with no `disabled` prop of their
// own: blocks pointer interaction and dims the block while the schema field is disabled.
export const disabledBlockSx = (disabled?: boolean) =>
  disabled ? { pointerEvents: "none", opacity: 0.6, cursor: "not-allowed" } : undefined;
